/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
export const Conversation = React.forwardRef<
  SVGSVGElement,
  Omit<React.SVGProps<SVGSVGElement>, "css">
>((props, ref) => (
  <svg
    fill="none"
    viewBox="0 0 182 91"
    ref={ref}
    css={{
      color: "#F4F6F8",
      height: "91px",
      width: "182px",
    }}
    {...props}
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      d="M1 90.5C1 40.794 41.294.5 91 .5s90 40.294 90 90H1z"
    />
    <path
      stroke="#424855"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M73.75 78.502a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5z"
    />
    <path fill="#F18686" d="M82.028 85.468A9 9 0 0 0 68.5 81.7" />
    <path
      stroke="#424855"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M82.028 85.468A9 9 0 0 0 68.5 81.7M108.25 78.502a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5z"
    />
    <path
      fill="#F18686"
      d="M99.973 85.468a9.005 9.005 0 0 1 9.849-5.321 9.003 9.003 0 0 1 3.679 1.553"
    />
    <path
      stroke="#424855"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M99.973 85.468a9.005 9.005 0 0 1 9.849-5.321 9.003 9.003 0 0 1 3.679 1.553M91 78.502a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5z"
    />
    <path
      fill="#74B0F4"
      d="M100.43 86a12.128 12.128 0 0 0-14.652-3.316A12.131 12.131 0 0 0 81.572 86"
    />
    <path
      stroke="#424855"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M100.43 86a12.128 12.128 0 0 0-14.652-3.316A12.131 12.131 0 0 0 81.572 86M98.5 59h-15v4.5L76 59h-6V41h28.5v18z"
    />
    <path
      stroke="#424855"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M79 47l-3 3 3 3M89.5 47l3 3-3 3M85 47l-1.5 6"
    />
    <path
      fill="#CAD0D8"
      fillRule="evenodd"
      d="M52.947 38.364c0 .627.472 1.136 1.053 1.136s1.053-.509 1.053-1.136v-1.811h1.81c.628 0 1.137-.472 1.137-1.053 0-.582-.509-1.053-1.136-1.053h-1.811v-1.81c0-.628-.472-1.137-1.053-1.137s-1.053.509-1.053 1.136v1.811h-1.81c-.628 0-1.137.471-1.137 1.053 0 .581.509 1.053 1.136 1.053h1.811v1.811zM117.947 54.364c0 .627.472 1.136 1.053 1.136s1.053-.509 1.053-1.136v-1.811h1.811c.627 0 1.136-.472 1.136-1.053 0-.582-.509-1.053-1.136-1.053h-1.811v-1.81c0-.628-.472-1.137-1.053-1.137s-1.053.509-1.053 1.136v1.811h-1.811c-.627 0-1.136.471-1.136 1.053 0 .581.509 1.053 1.136 1.053h1.811v1.811zM153.947 84.364c0 .627.472 1.136 1.053 1.136s1.053-.509 1.053-1.136v-1.811h1.811c.627 0 1.136-.472 1.136-1.053 0-.582-.509-1.053-1.136-1.053h-1.811v-1.81c0-.628-.472-1.137-1.053-1.137s-1.053.509-1.053 1.136v1.811h-1.811c-.627 0-1.136.471-1.136 1.053 0 .581.509 1.053 1.136 1.053h1.811v1.811zM46.5 59.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM33.5 36.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM18.5 81.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM93.5 12.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM79.5 29.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM124.5 18.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM135.5 37.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM164.5 66.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM139.5 63.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM103.5 29.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M103.5 28a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
      clipRule="evenodd"
    />
    <path
      fill="#CAD0D8"
      fillRule="evenodd"
      d="M67.5 17.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M67.5 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
      clipRule="evenodd"
    />
    <path
      fill="#CAD0D8"
      fillRule="evenodd"
      d="M128.5 82.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M128.5 81a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
      clipRule="evenodd"
    />
    <path
      fill="#CAD0D8"
      fillRule="evenodd"
      d="M153.5 44.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M153.5 43a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
      clipRule="evenodd"
    />
    <path
      fill="#CAD0D8"
      fillRule="evenodd"
      d="M46.5 80.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M46.5 79a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
      clipRule="evenodd"
    />
    <path
      fill="#CAD0D8"
      fillRule="evenodd"
      d="M24.5 60.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24.5 59a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
      clipRule="evenodd"
    />
  </svg>
));
